import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import TextEditor from "../TextEditor";
import { FormattedMessage } from "react-intl";

export const JobDescription = forwardRef((props: any, ref) => {
  const [description, setDescription] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    setDescription(props?.data?.job_description);
  }, [props?.data]);

  useEffect(() => {
    const data = {
      job_description: description,
    };
    props?.HandleDataProps(data);
  }, [description]);

  useImperativeHandle(ref, () => ({
    validateData: () => {
      const plainText = description
        ?.trim()
        .replace(/<[^>]+>/g, "")
        .trim();

      if (!plainText) {
        setError("Job description is required");
        return false;
      }

      setError("");
      return true;
    },
  }));

  return (
    <>
      <p className=" text-base">
        <FormattedMessage
          id="RECRUITER.POSTJOB.JOBDESCRIPTION.TITLE"
          defaultMessage="Job Descripion"
        />
      </p>
      <p className="text-sm text-black mt-1 mb-2">
        <FormattedMessage
          id="RECRUITER.POSTJOB.JOBDESCRIPTION.HELPER_TEXT"
          defaultMessage="Add a description to attract the right candidate. Include information about what the job will entail and any expectations you have for potential applicants."
        />
      </p>
      {description && (
        <TextEditor setdescription={setDescription} description={description} />
      )}
      {error && <div className="text-red-500 text-sm mt-2">{error}</div>}
    </>
  );
});
